export default "__VITE_ASSET__Dd37A7xK__"